<ngx-ui-loader></ngx-ui-loader>
<app-background-image>
  <app-splash-screen
    [duration]="2"
    [animationDuration]="0.5"
  ></app-splash-screen>
  <div [@fadeInOut] ngClass="app-wrapper-animations">
    <div class="app-wrapper">
      <router-outlet></router-outlet>
    </div>
  </div>
</app-background-image>
